module.exports = __webpack_public_path__ + "static/DSC_9357-f785b6ef8fb74f80bbd3ecde8c9c56e1.jpg";